// @flow
import type { AxiosPromise, AxiosInstance } from "axios";

const syncListingPhotos = (
  listingId: string,
  photoIds: Array<string>
): ((apiInstance: AxiosInstance) => AxiosPromise<>) => (apiInstance) => {
  return apiInstance.post(`/v5/listings/${listingId}/photos`, {
    photo_ids: photoIds
  });
};

export default syncListingPhotos;
